import React, { useEffect } from 'react'
import './aboutInfo.css'
import Aos from "aos";
import "aos/dist/aos.css";

export default function AboutInfo() {

    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);

  return (
    <div>
       <div className="brandStory-layout-91">
            <div className="brandStory-content2">
              <div className="brandStory-column11" data-aos="fade-left" data-aos-duration="400">
                <div className="brandStory-heading12">Your Dream, Our Passion</div>
              </div>

              <div className="brandStory-column12"
                data-aos="fade-left" data-aos-duration="600"
              >
                {/* <div className="brandStory-date">Brand Purpose</div> */}
                <div className="brandStory-text-suspendisse-varius1">
                    At Stannum HR Consultancies LLC, we specialize in providing comprehensive HR solutions and work visa 
                        services in Dubai. As a trusted partner, we combine our extensive industry expertise with an 
                        in-depth understanding of local regulations to deliver seamless and efficient services. 
                        Our mission is to simplify the complexities of securing work visas and managing HR requirements, 
                        ensuring a hassle-free experience for our clients. Whether you're an organization looking to 
                        streamline your HR operations or a professional seeking a smooth relocation process, 
                        Stannum HR Consultancies LLC is here to support you every step of the way.
                </div>
              </div>
            </div>
            {/* <img
              className="brandStory-placeholder-lightbox-icon"
              alt="loading"
              src={BrandStoryImage}
            /> */}
          </div>
    </div>
  )
}
